import { ThunkAction } from "redux-thunk";
import { Action, ActionCreator, Dispatch } from "redux";
import {
	DocumentApproval,
	DocumentApprovalCreateRequest,
	DocumentApprovalUpdateRequest
} from "@/Contracts/DocumentApprovals";
import { SalesActivityAutomationMetadataFilter } from "@/Contracts/Others/SalesActivity";
import { GlobalState } from "@/Reducers/interface";
import {
	createDocumentApprovalRule,
	getAllDocumentApprovalRulesBySales,
	getDocumentFilterMetadata,
	deleteDocumentApprovalRule,
	updateDocumentApprovalRule,
	getDocumentApprovalRule,
	getDocumentApprovalRuleBySales,
	getAllDocumentApprovalRules
} from "../../Services/DocumentApproval";

export enum DocumentApprovalRuleActionTypes {
	SHOW_DOCUMENT_APPROVAL_RULE_LOADER = "SHOW_DOCUMENT_APPROVAL_RULE_LOADER",
	HIDE_DOCUMENT_APPROVAL_RULE_LOADER = "HIDE_DOCUMENT_APPROVAL_RULE_LOADER",

	FETCH_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA_REQUESTED = "FETCH_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA_REQUESTED",
	FETCH_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA_SUCCESSFUL = "FETCH_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA_SUCCESSFUL",
	FETCH_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA_FAILED = "FETCH_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA_FAILED",

	RESET_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA = "RESET_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA",

	UPDATE_CURRENT_ACTIVE_DOCUMENT_APPROVAL_RULE = "UPDATE_CURRENT_ACTIVE_DOCUMENT_APPROVAL_RULE",
	RESET_CURRENT_ACTIVE_DOCUMENT_APPROVAL_RULE = "RESET_CURRENT_ACTIVE_DOCUMENT_APPROVAL_RULE",

	CREATE_DOCUMENT_APPROVAL_RULE_REQUESTED = "CREATE_DOCUMENT_APPROVAL_RULE_REQUESTED",
	CREATE_DOCUMENT_APPROVAL_RULE_SUCCESSFUL = "CREATE_DOCUMENT_APPROVAL_RULE_SUCCESSFUL",
	CREATE_DOCUMENT_APPROVAL_RULE_FAILED = "CREATE_DOCUMENT_APPROVAL_RULE_FAILED",

	DELETE_DOCUMENT_APPROVAL_RULE_REQUESTED = "DELETE_DOCUMENT_APPROVAL_RULE_REQUESTED",
	DELETE_DOCUMENT_APPROVAL_RULE_SUCCESSFUL = "DELETE_DOCUMENT_APPROVAL_RULE_SUCCESSFUL",
	DELETE_DOCUMENT_APPROVAL_RULE_FAILED = "DELETE_DOCUMENT_APPROVAL_RULE_FAILED",

	FETCH_ALL_DOCUMENT_APPROVAL_RULES_REQUESTED = "FETCH_ALL_DOCUMENT_APPROVAL_RULES_REQUESTED",
	FETCH_ALL_DOCUMENT_APPROVAL_RULES_SUCCESSFUL = "FETCH_ALL_DOCUMENT_APPROVAL_RULES_SUCCESSFUL",
	FETCH_ALL_DOCUMENT_APPROVAL_RULES_FAILED = "FETCH_ALL_DOCUMENT_APPROVAL_RULES_FAILED",

	FETCH_DOCUMENT_APPROVAL_RULE_REQUESTED = "FETCH_DOCUMENT_APPROVAL_RULE_REQUESTED",
	FETCH_DOCUMENT_APPROVAL_RULE_SUCCESSFUL = "FETCH_DOCUMENT_APPROVAL_RULE_SUCCESSFUL",
	FETCH_DOCUMENT_APPROVAL_RULE_FAILED = "FETCH_DOCUMENT_APPROVAL_RULE_FAILED",

	RESET_DOCUMENT_APPROVAL_RULES_LIST = "RESET_DOCUMENT_APPROVAL_RULES_LIST",

	SHOW_EDIT_DOCUMENT_APPROVERS_DRAWER = "SHOW_EDIT_DOCUMENT_APPROVERS_DRAWER",
	HIDE_EDIT_DOCUMENT_APPROVERS_DRAWER = "HIDE_EDIT_DOCUMENT_APPROVERS_DRAWER",

	UPDATE_DOCUMENT_APPROVAL_RULE_REQUESTED = "UPDATE_DOCUMENT_APPROVAL_RULE_REQUESTED",
	UPDATE_DOCUMENT_APPROVAL_RULE_SUCCESSFUL = "UPDATE_DOCUMENT_APPROVAL_RULE_SUCCESSFUL",
	UPDATE_DOCUMENT_APPROVAL_RULE_FAILED = "UPDATE_DOCUMENT_APPROVAL_RULE_FAILED",
	UPDATE_APPROVAL_FINAL_MODAL_VISIBILITY = "UPDATE_APPROVAL_FINAL_MODAL_VISIBILITY"
}

export type ShowDocumentApprovalRuleLoaderAction =
	Action<DocumentApprovalRuleActionTypes.SHOW_DOCUMENT_APPROVAL_RULE_LOADER>;

export type HideDocumentApprovalRuleLoaderAction =
	Action<DocumentApprovalRuleActionTypes.HIDE_DOCUMENT_APPROVAL_RULE_LOADER>;
export type ShowEditDocumentApproversDrawerAction =
	Action<DocumentApprovalRuleActionTypes.SHOW_EDIT_DOCUMENT_APPROVERS_DRAWER>;

export type HideEditDocumentApproversDrawerAction =
	Action<DocumentApprovalRuleActionTypes.HIDE_EDIT_DOCUMENT_APPROVERS_DRAWER>;

export type FetchDocumentApprovalRuleFiltersMetadataRequestedAction =
	Action<DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA_REQUESTED>;

export interface FetchDocumentApprovalRuleFiltersMetadataSuccessfulAction
	extends Action<DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA_SUCCESSFUL> {
	readonly filters: SalesActivityAutomationMetadataFilter[];
}

export type FetchDocumentApprovalRuleFiltersMetadataFailedAction =
	Action<DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA_FAILED>;

export type ResetDocumentApprovalFiltersMetadataAction =
	Action<DocumentApprovalRuleActionTypes.RESET_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA>;

export interface UpdateCurrentActiveDocumentApprovalRuleAction
	extends Action<DocumentApprovalRuleActionTypes.UPDATE_CURRENT_ACTIVE_DOCUMENT_APPROVAL_RULE> {
	readonly documentApprovalRule: DocumentApproval;
}

export type ResetCurrentActiveDocumentApprovalRuleAction =
	Action<DocumentApprovalRuleActionTypes.RESET_CURRENT_ACTIVE_DOCUMENT_APPROVAL_RULE>;

export type CreateDocumentApprovalRuleRequestedAction =
	Action<DocumentApprovalRuleActionTypes.CREATE_DOCUMENT_APPROVAL_RULE_REQUESTED>;

export interface CreateDocumentApprovalRuleSuccessfulAction
	extends Action<DocumentApprovalRuleActionTypes.CREATE_DOCUMENT_APPROVAL_RULE_SUCCESSFUL> {
	readonly documentApprovalRule: DocumentApproval;
}

export type CreateDocumentApprovalRuleFailedAction =
	Action<DocumentApprovalRuleActionTypes.CREATE_DOCUMENT_APPROVAL_RULE_FAILED>;

export type DeleteDocumentApprovalRuleRequestedAction =
	Action<DocumentApprovalRuleActionTypes.DELETE_DOCUMENT_APPROVAL_RULE_REQUESTED>;

export interface DeleteDocumentApprovalRuleSuccessfulAction
	extends Action<DocumentApprovalRuleActionTypes.DELETE_DOCUMENT_APPROVAL_RULE_SUCCESSFUL> {
	readonly documentApprovalRuleId: string;
}

export type DeleteDocumentApprovalRuleFailedAction =
	Action<DocumentApprovalRuleActionTypes.DELETE_DOCUMENT_APPROVAL_RULE_FAILED>;

export type FetchAllDocumentApprovalRulesRequestedAction =
	Action<DocumentApprovalRuleActionTypes.FETCH_ALL_DOCUMENT_APPROVAL_RULES_REQUESTED>;

export interface FetchAllDocumentApprovalRulesSuccessfulAction
	extends Action<DocumentApprovalRuleActionTypes.FETCH_ALL_DOCUMENT_APPROVAL_RULES_SUCCESSFUL> {
	readonly documentApprovalRules: DocumentApproval[];
}

export type FetchAllDocumentApprovalRulesFailedAction =
	Action<DocumentApprovalRuleActionTypes.FETCH_ALL_DOCUMENT_APPROVAL_RULES_FAILED>;
export type FetchDocumentApprovalRuleRequestedAction =
	Action<DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_REQUESTED>;

export interface FetchDocumentApprovalRuleSuccessfulAction
	extends Action<DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_SUCCESSFUL> {
	readonly documentApprovalRule: DocumentApproval;
}

export type FetchDocumentApprovalRuleFailedAction =
	Action<DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_FAILED>;

export type ResetDocumentApprovalRulesListAction =
	Action<DocumentApprovalRuleActionTypes.RESET_DOCUMENT_APPROVAL_RULES_LIST>;

export type UpdateDocumentApprovalRuleRequestedAction =
	Action<DocumentApprovalRuleActionTypes.UPDATE_DOCUMENT_APPROVAL_RULE_REQUESTED>;
export interface UpdateDocumentApprovalRuleSuccessfulAction
	extends Action<DocumentApprovalRuleActionTypes.UPDATE_DOCUMENT_APPROVAL_RULE_SUCCESSFUL> {
	readonly documentApprovalRule: DocumentApproval;
}
export type UpdateDocumentApprovalRuleFailedAction =
	Action<DocumentApprovalRuleActionTypes.UPDATE_DOCUMENT_APPROVAL_RULE_FAILED>;

export interface UpdateDocumentApprovalFinalModalVisibility
	extends Action<DocumentApprovalRuleActionTypes.UPDATE_APPROVAL_FINAL_MODAL_VISIBILITY> {
	visible: boolean;
}

export type DocumentApprovalRuleActions =
	| ShowDocumentApprovalRuleLoaderAction
	| HideDocumentApprovalRuleLoaderAction
	| FetchDocumentApprovalRuleFiltersMetadataRequestedAction
	| FetchDocumentApprovalRuleFiltersMetadataSuccessfulAction
	| FetchDocumentApprovalRuleFiltersMetadataFailedAction
	| ResetDocumentApprovalFiltersMetadataAction
	| UpdateCurrentActiveDocumentApprovalRuleAction
	| ResetCurrentActiveDocumentApprovalRuleAction
	| CreateDocumentApprovalRuleRequestedAction
	| CreateDocumentApprovalRuleSuccessfulAction
	| CreateDocumentApprovalRuleFailedAction
	| DeleteDocumentApprovalRuleRequestedAction
	| DeleteDocumentApprovalRuleSuccessfulAction
	| DeleteDocumentApprovalRuleFailedAction
	| FetchAllDocumentApprovalRulesRequestedAction
	| FetchAllDocumentApprovalRulesSuccessfulAction
	| FetchAllDocumentApprovalRulesFailedAction
	| ResetDocumentApprovalRulesListAction
	| FetchDocumentApprovalRuleRequestedAction
	| FetchDocumentApprovalRuleSuccessfulAction
	| FetchDocumentApprovalRuleFailedAction
	| ShowEditDocumentApproversDrawerAction
	| HideEditDocumentApproversDrawerAction
	| UpdateDocumentApprovalRuleRequestedAction
	| UpdateDocumentApprovalRuleSuccessfulAction
	| UpdateDocumentApprovalRuleFailedAction
	| UpdateDocumentApprovalFinalModalVisibility;

export interface DocumentApprovalRuleDispatch {
	showLoader: ActionCreator<
		ThunkAction<
			ShowDocumentApprovalRuleLoaderAction,
			GlobalState,
			null,
			ShowDocumentApprovalRuleLoaderAction
		>
	>;
	hideLoader: ActionCreator<
		ThunkAction<
			HideDocumentApprovalRuleLoaderAction,
			GlobalState,
			null,
			HideDocumentApprovalRuleLoaderAction
		>
	>;
	fetchDocumentFiltersMetadata: ActionCreator<
		ThunkAction<
			Promise<FetchDocumentApprovalRuleFiltersMetadataSuccessfulAction>,
			GlobalState,
			null,
			FetchDocumentApprovalRuleFiltersMetadataSuccessfulAction
		>
	>;

	fetchAllDocumentApprovalRules: ActionCreator<
		ThunkAction<
			Promise<FetchAllDocumentApprovalRulesSuccessfulAction>,
			GlobalState,
			boolean,
			FetchAllDocumentApprovalRulesSuccessfulAction
		>
	>;

	resetDocumentApprovalRulesList: ActionCreator<
		ThunkAction<
			ResetDocumentApprovalRulesListAction,
			GlobalState,
			null,
			ResetDocumentApprovalRulesListAction
		>
	>;

	resetDocumentFiltersMetadata: ActionCreator<
		ThunkAction<
			ResetDocumentApprovalFiltersMetadataAction,
			GlobalState,
			null,
			ResetDocumentApprovalFiltersMetadataAction
		>
	>;

	updateCurrentActiveDocumentApprovalRule: ActionCreator<
		ThunkAction<
			UpdateCurrentActiveDocumentApprovalRuleAction,
			GlobalState,
			DocumentApproval,
			UpdateCurrentActiveDocumentApprovalRuleAction
		>
	>;
	resetCurrentActiveDocumentApprovalRule: ActionCreator<
		ThunkAction<
			ResetCurrentActiveDocumentApprovalRuleAction,
			GlobalState,
			null,
			ResetCurrentActiveDocumentApprovalRuleAction
		>
	>;

	createDocumentApprovalRule: ActionCreator<
		ThunkAction<
			Promise<CreateDocumentApprovalRuleSuccessfulAction>,
			GlobalState,
			DocumentApprovalCreateRequest,
			CreateDocumentApprovalRuleSuccessfulAction
		>
	>;

	deleteDocumentApprovalRule: ActionCreator<
		ThunkAction<
			Promise<DeleteDocumentApprovalRuleSuccessfulAction>,
			GlobalState,
			string,
			DeleteDocumentApprovalRuleSuccessfulAction
		>
	>;
	fetchDocumentApprovalRule: ActionCreator<
		ThunkAction<
			Promise<FetchDocumentApprovalRuleSuccessfulAction>,
			GlobalState,
			string,
			FetchDocumentApprovalRuleSuccessfulAction
		>
	>;
	showEditDocumentApproverDrawer: ActionCreator<
		ThunkAction<
			ShowEditDocumentApproversDrawerAction,
			GlobalState,
			null,
			ShowEditDocumentApproversDrawerAction
		>
	>;
	hideEditDocumentApproverDrawer: ActionCreator<
		ThunkAction<
			HideEditDocumentApproversDrawerAction,
			GlobalState,
			null,
			HideEditDocumentApproversDrawerAction
		>
	>;
	updateDocumentApprovalRule: ActionCreator<
		ThunkAction<
			Promise<UpdateDocumentApprovalRuleSuccessfulAction>,
			GlobalState,
			DocumentApprovalUpdateRequest,
			UpdateDocumentApprovalRuleSuccessfulAction
		>
	>;
	UpdateDocumentApprovalFinalModalVisibility: ActionCreator<
		ThunkAction<
			UpdateDocumentApprovalFinalModalVisibility,
			GlobalState,
			{ visible: boolean },
			UpdateDocumentApprovalFinalModalVisibility
		>
	>;
}

export const DocumentApprovalRuleActionCreators: DocumentApprovalRuleDispatch =
	{
		showLoader: () => {
			return (
				dispatch: Dispatch
			): ShowDocumentApprovalRuleLoaderAction => {
				const showDocumentApprovalRuleLoaderAction: ShowDocumentApprovalRuleLoaderAction =
					{
						type: DocumentApprovalRuleActionTypes.SHOW_DOCUMENT_APPROVAL_RULE_LOADER
					};
				return dispatch(showDocumentApprovalRuleLoaderAction);
			};
		},
		hideLoader: () => {
			return (
				dispatch: Dispatch
			): HideDocumentApprovalRuleLoaderAction => {
				const hideDocumentApprovalRuleLoaderAction: HideDocumentApprovalRuleLoaderAction =
					{
						type: DocumentApprovalRuleActionTypes.HIDE_DOCUMENT_APPROVAL_RULE_LOADER
					};
				return dispatch(hideDocumentApprovalRuleLoaderAction);
			};
		},
		fetchDocumentFiltersMetadata: () => {
			return async (
				dispatch: Dispatch
			): Promise<FetchDocumentApprovalRuleFiltersMetadataSuccessfulAction> => {
				const fetchDocumentApprovalRuleFiltersMetadataRequestedAction: FetchDocumentApprovalRuleFiltersMetadataRequestedAction =
					{
						type: DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA_REQUESTED
					};

				dispatch(
					fetchDocumentApprovalRuleFiltersMetadataRequestedAction
				);

				try {
					const filtersResponse = await getDocumentFilterMetadata();

					const fetchDocumentApprovalRuleFiltersMetadataSuccessfulAction: FetchDocumentApprovalRuleFiltersMetadataSuccessfulAction =
						{
							type: DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA_SUCCESSFUL,
							filters: filtersResponse.filters
						};

					return dispatch(
						fetchDocumentApprovalRuleFiltersMetadataSuccessfulAction
					);
				} catch (error) {
					const fetchDocumentApprovalRuleFiltersMetadataFailedAction: FetchDocumentApprovalRuleFiltersMetadataFailedAction =
						{
							type: DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA_FAILED
						};

					dispatch(
						fetchDocumentApprovalRuleFiltersMetadataFailedAction
					);

					return Promise.reject(error);
				}
			};
		},
		resetDocumentFiltersMetadata: () => {
			return (
				dispatch: Dispatch
			): ResetDocumentApprovalFiltersMetadataAction => {
				const resetDocumentApprovalFiltersMetadataAction: ResetDocumentApprovalFiltersMetadataAction =
					{
						type: DocumentApprovalRuleActionTypes.RESET_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA
					};

				return dispatch(resetDocumentApprovalFiltersMetadataAction);
			};
		},
		updateCurrentActiveDocumentApprovalRule: (
			documentApprovalRule: DocumentApproval
		) => {
			return (
				dispatch: Dispatch
			): UpdateCurrentActiveDocumentApprovalRuleAction => {
				const updateCurrentActiveDocumentApprovalRuleAction: UpdateCurrentActiveDocumentApprovalRuleAction =
					{
						type: DocumentApprovalRuleActionTypes.UPDATE_CURRENT_ACTIVE_DOCUMENT_APPROVAL_RULE,
						documentApprovalRule
					};

				return dispatch(updateCurrentActiveDocumentApprovalRuleAction);
			};
		},
		resetCurrentActiveDocumentApprovalRule: () => {
			return (
				dispatch: Dispatch
			): ResetCurrentActiveDocumentApprovalRuleAction => {
				const resetCurrentActiveDocumentApprovalRuleAction: ResetCurrentActiveDocumentApprovalRuleAction =
					{
						type: DocumentApprovalRuleActionTypes.RESET_CURRENT_ACTIVE_DOCUMENT_APPROVAL_RULE
					};

				return dispatch(resetCurrentActiveDocumentApprovalRuleAction);
			};
		},
		createDocumentApprovalRule: (
			createDocumentApprovalRuleRequest: DocumentApprovalCreateRequest,
			apiVersion = "v2"
		) => {
			return async (
				dispatch: Dispatch
			): Promise<CreateDocumentApprovalRuleSuccessfulAction> => {
				const createDocumentApprovalRuleRequestedAction: CreateDocumentApprovalRuleRequestedAction =
					{
						type: DocumentApprovalRuleActionTypes.CREATE_DOCUMENT_APPROVAL_RULE_REQUESTED
					};
				dispatch(createDocumentApprovalRuleRequestedAction);

				try {
					// sent the request to the API
					const response = await createDocumentApprovalRule(
						createDocumentApprovalRuleRequest,
						apiVersion
					);

					const createDocumentApprovalRuleSuccessfulAction: CreateDocumentApprovalRuleSuccessfulAction =
						{
							type: DocumentApprovalRuleActionTypes.CREATE_DOCUMENT_APPROVAL_RULE_SUCCESSFUL,
							documentApprovalRule: response
						};

					return dispatch(createDocumentApprovalRuleSuccessfulAction);
				} catch (error) {
					const createDocumentApprovalRuleFailedAction: CreateDocumentApprovalRuleFailedAction =
						{
							type: DocumentApprovalRuleActionTypes.CREATE_DOCUMENT_APPROVAL_RULE_FAILED
						};

					dispatch(createDocumentApprovalRuleFailedAction);

					return Promise.reject(error);
				}
			};
		},
		deleteDocumentApprovalRule: (
			documentApprovalRuleId: string,
			apiVersion = "v2"
		) => {
			return async (
				dispatch: Dispatch
			): Promise<DeleteDocumentApprovalRuleSuccessfulAction> => {
				const deleteDocumentApprovalRuleRequestedAction: DeleteDocumentApprovalRuleRequestedAction =
					{
						type: DocumentApprovalRuleActionTypes.DELETE_DOCUMENT_APPROVAL_RULE_REQUESTED
					};
				dispatch(deleteDocumentApprovalRuleRequestedAction);

				try {
					// sent the request to the API
					await deleteDocumentApprovalRule(
						documentApprovalRuleId,
						apiVersion
					);

					const deleteDocumentApprovalRuleSuccessfulAction: DeleteDocumentApprovalRuleSuccessfulAction =
						{
							type: DocumentApprovalRuleActionTypes.DELETE_DOCUMENT_APPROVAL_RULE_SUCCESSFUL,
							documentApprovalRuleId: documentApprovalRuleId
						};

					return dispatch(deleteDocumentApprovalRuleSuccessfulAction);
				} catch (error) {
					const deleteDocumentApprovalRuleFailedAction: DeleteDocumentApprovalRuleFailedAction =
						{
							type: DocumentApprovalRuleActionTypes.DELETE_DOCUMENT_APPROVAL_RULE_FAILED
						};

					dispatch(deleteDocumentApprovalRuleFailedAction);

					return Promise.reject(error);
				}
			};
		},
		fetchAllDocumentApprovalRules: (isFilterV2Enabled: boolean) => {
			return async (
				dispatch: Dispatch
			): Promise<FetchAllDocumentApprovalRulesSuccessfulAction> => {
				const fetchAllDocumentApprovalRulesRequestedAction: FetchAllDocumentApprovalRulesRequestedAction =
					{
						type: DocumentApprovalRuleActionTypes.FETCH_ALL_DOCUMENT_APPROVAL_RULES_REQUESTED
					};

				dispatch(fetchAllDocumentApprovalRulesRequestedAction);

				try {
					const fecthDocumentApprovalRules = isFilterV2Enabled
						? getAllDocumentApprovalRules
						: getAllDocumentApprovalRulesBySales;
					const response = await fecthDocumentApprovalRules();

					const fetchAllDocumentApprovalRulesSuccessfulAction: FetchAllDocumentApprovalRulesSuccessfulAction =
						{
							type: DocumentApprovalRuleActionTypes.FETCH_ALL_DOCUMENT_APPROVAL_RULES_SUCCESSFUL,
							documentApprovalRules: response.data
						};

					return dispatch(
						fetchAllDocumentApprovalRulesSuccessfulAction
					);
				} catch (error) {
					const fetchAllDocumentApprovalRulesFailedAction: FetchAllDocumentApprovalRulesFailedAction =
						{
							type: DocumentApprovalRuleActionTypes.FETCH_ALL_DOCUMENT_APPROVAL_RULES_FAILED
						};

					dispatch(fetchAllDocumentApprovalRulesFailedAction);

					return Promise.reject(error);
				}
			};
		},
		resetDocumentApprovalRulesList: () => {
			return (
				dispatch: Dispatch
			): ResetDocumentApprovalRulesListAction => {
				const resetDocumentApprovalRulesListAction: ResetDocumentApprovalRulesListAction =
					{
						type: DocumentApprovalRuleActionTypes.RESET_DOCUMENT_APPROVAL_RULES_LIST
					};

				return dispatch(resetDocumentApprovalRulesListAction);
			};
		},
		fetchDocumentApprovalRule: (
			documentApprovalRuleId: string,
			isFilterV2Enabled: boolean
		) => {
			return async (
				dispatch: Dispatch
			): Promise<FetchDocumentApprovalRuleSuccessfulAction> => {
				const fetchDocumentApprovalRuleRequestedAction: FetchDocumentApprovalRuleRequestedAction =
					{
						type: DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_REQUESTED
					};

				dispatch(fetchDocumentApprovalRuleRequestedAction);

				try {
					const fecthDocumentApprovalRule = isFilterV2Enabled
						? getDocumentApprovalRule
						: getDocumentApprovalRuleBySales;
					const response = await fecthDocumentApprovalRule(
						documentApprovalRuleId
					);
					const fetchDocumentApprovalRuleSuccessfulAction: FetchDocumentApprovalRuleSuccessfulAction =
						{
							type: DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_SUCCESSFUL,
							documentApprovalRule: response
						};

					return dispatch(fetchDocumentApprovalRuleSuccessfulAction);
				} catch (error) {
					const fetchDocumentApprovalRuleFailedAction: FetchDocumentApprovalRuleFailedAction =
						{
							type: DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_FAILED
						};

					dispatch(fetchDocumentApprovalRuleFailedAction);

					return Promise.reject(error);
				}
			};
		},
		showEditDocumentApproverDrawer: () => {
			return (
				dispatch: Dispatch
			): ShowEditDocumentApproversDrawerAction => {
				const showEditDocumentApproversDrawerAction: ShowEditDocumentApproversDrawerAction =
					{
						type: DocumentApprovalRuleActionTypes.SHOW_EDIT_DOCUMENT_APPROVERS_DRAWER
					};
				return dispatch(showEditDocumentApproversDrawerAction);
			};
		},
		hideEditDocumentApproverDrawer: () => {
			return (
				dispatch: Dispatch
			): HideEditDocumentApproversDrawerAction => {
				const hideEditDocumentApproversDrawerAction: HideEditDocumentApproversDrawerAction =
					{
						type: DocumentApprovalRuleActionTypes.HIDE_EDIT_DOCUMENT_APPROVERS_DRAWER
					};
				return dispatch(hideEditDocumentApproversDrawerAction);
			};
		},
		updateDocumentApprovalRule: (
			documentApprovalRuleEditRequest: DocumentApprovalUpdateRequest,
			apiVersion = "v2"
		) => {
			return async (
				dispatch: Dispatch
			): Promise<UpdateDocumentApprovalRuleSuccessfulAction> => {
				const updateDocumentApprovalRuleRequestedRequest: UpdateDocumentApprovalRuleRequestedAction =
					{
						type: DocumentApprovalRuleActionTypes.UPDATE_DOCUMENT_APPROVAL_RULE_REQUESTED
					};
				dispatch(updateDocumentApprovalRuleRequestedRequest);

				try {
					const response = await updateDocumentApprovalRule(
						documentApprovalRuleEditRequest,
						apiVersion
					);

					const updateDocumentApprovalRuleSuccessfulRequest: UpdateDocumentApprovalRuleSuccessfulAction =
						{
							type: DocumentApprovalRuleActionTypes.UPDATE_DOCUMENT_APPROVAL_RULE_SUCCESSFUL,
							documentApprovalRule: response
						};
					return dispatch(
						updateDocumentApprovalRuleSuccessfulRequest
					);
				} catch (error) {
					const updateDocumentApprovalRuleFailedRequest: UpdateDocumentApprovalRuleFailedAction =
						{
							type: DocumentApprovalRuleActionTypes.UPDATE_DOCUMENT_APPROVAL_RULE_FAILED
						};
					dispatch(updateDocumentApprovalRuleFailedRequest);

					return Promise.reject(error);
				}
			};
		},
		UpdateDocumentApprovalFinalModalVisibility: (visible: boolean) => {
			return (
				dispatch: Dispatch
			): UpdateDocumentApprovalFinalModalVisibility => {
				const updateApprovalFinalModalVisibilityAction: UpdateDocumentApprovalFinalModalVisibility =
					{
						type: DocumentApprovalRuleActionTypes.UPDATE_APPROVAL_FINAL_MODAL_VISIBILITY,
						visible
					};
				return dispatch(updateApprovalFinalModalVisibilityAction);
			};
		}
	};
